import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Button, Dialog, Grid, TextField, DialogActions, DialogContent, DialogTitle, CircularProgress, } from '@material-ui/core';
import { globalGetService, globalPostService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus, } from '../../../utils_v2';
import TemplateSectionList from './TemplateSectionList';
import { EmptyCollection } from '../../../shared_elements';

const SectionImportTemplate = ({ params, sectionList, getResponseBack, pageLoading, initialLoader }) => {
    const [modal, setModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [importCrud, setImportCrud] = useState({ template: null });
    const [templates, setTemplates] = useState([])
    useEffect(() => { getFormTemplates(); }, [])
    const getFormTemplates = () => {
        globalGetService(`technical/templates/`, { type: 'T004', is_section_template: true })
            .then(response => {
                if (checkApiStatus(response)) { setTemplates(response.data.data.list) } 
            })
    }
    const onChangeTemplate = (template) => {
        let updatedTemplate = { ...template };
        if (params?.type === "apu" || params?.type === "lg") {
            const idsToRemove = [3, 14];
            updatedTemplate = {
                ...template,
                t004_sync_form: template?.t004_sync_form?.filter((id) => !idsToRemove.includes(id)),
                section_data: template?.section_data?.filter((section) => !idsToRemove.includes(section?.reference_id)),
            };
        }
        setImportCrud((prev) => ({ ...prev,template: updatedTemplate,sectionData: updatedTemplate?.section_data, }));
    };
    const onSetupTemplate = () => {
        const queryParams = new URLSearchParams({ asset_type: params.type, template_id: importCrud?.template?.id }).toString();
        setLoading(true)
        globalPostService(`technical/v2/workorder/${params.workOrderSlug}/default-summary-sections/?${queryParams}`)
            .then(response => {
                if (checkApiStatus(response)) { setModal(false); getResponseBack(); setImportCrud({}) }
                setLoading(false)
            })
    }
    return (
        <>
            {!pageLoading && !initialLoader && sectionList?.length === 0 && <div className='import-form-template'>
                <h4>There is no section mapped to this form right now</h4>
                <p>Please choose the template to map the section</p>
                <Button onClick={() => { setModal(true) }} color='primary' variant='outlined' size='small'>Import Template</Button>
            </div>}

            {modal ?
                <Dialog
                    open={modal}
                    onClose={() => { setModal(false) }}
                    className='project-management-modal'
                    maxWidth="lg"
                    fullWidth
                >
                    <DialogTitle id="scroll-dialog-title">
                        Import Template
                    </DialogTitle>
                    <DialogContent dividers={true} >
                        <div className='t004-import-template' >
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={4}>
                                    <Autocomplete
                                        options={templates}
                                        getOptionLabel={option => option.name}
                                        id="template"
                                        disableClearable
                                        value={importCrud.template}
                                        onChange={(e, value) => onChangeTemplate(value)}
                                        renderInput={params => <TextField required {...params} label="Select Template" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                {!importCrud?.template && <div className='import-form-template'> <div style={{ background: "#f1f1f1", marginTop: "8px" }}>   <EmptyCollection title="Please choose the template to map the section" /></div> </div>}
                                <TemplateSectionList importCrud={importCrud} />

                            </Grid>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} onClick={() => { setModal(false); setImportCrud({ templates: null, sectionData: [] }) }} color="primary" size='small' variant='outlined'>Cancel</Button>
                        {importCrud?.template ?
                            <Button disabled={isLoading} onClick={onSetupTemplate} color="primary" size='small' variant='contained'>
                                {isLoading ? <CircularProgress size={20} /> : 'Proceed'}
                            </Button> : null
                        }
                    </DialogActions>
                </Dialog> : null
            }
        </>
    )

}
export default withRouter(SectionImportTemplate);